import { createTheme } from "@mui/material/styles";

const staticPageTheme = createTheme({
  palette: {
    primary: {
      main: "#f97316",
      light: "#fb923c",
      dark: "#ea580c",
      contrastText: "#fff",
    },
    secondary: {
      main: "#0f172a",
      light: "#334155",
      dark: "#020617",
    },
    background: {
      default: "#ffffff",
      paper: "#f8fafc",
    },
    text: {
      primary: "#0f172a",
      secondary: "#475569",
    },
  },
  typography: {
    fontFamily: "'Barlow', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "3rem" },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "2.25rem" },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "1.75rem" },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "1.5rem" },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 500, fontSize: "1.25rem" },
    body1: { fontSize: "1rem", lineHeight: 1.7, color: "rgba(255,255,255,0.82)" },
    body2: { fontSize: "0.875rem", lineHeight: 1.6, color: "rgba(255,255,255,0.82)" },
    button: { textTransform: "none" as const, fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          padding: "10px 28px",
          fontSize: "1rem",
        },
        containedPrimary: {
          "&:hover": { backgroundColor: "#ea580c" },
        },
      },
    },
  },
});

export default staticPageTheme;
